import completeSadCloud from "@/assets/mascot/feedback/completeSadCloud.webp";
import completeFriendlyCloud from "@/assets/mascot/feedback/completeFriendlyCloud.webp";
import completeHelloCloud from "@/assets/mascot/feedback/completeHelloCloud.webp";
import completedAlertCloud from "@/assets/mascot/feedback/completedAlertCloud.png";

/**
 * Mapping de mascotas por variante semántica.
 *
 * Cómo extender:
 *   1. Agregá el asset en `src/assets/mascot/feedback/`.
 *   2. Importalo arriba con un nombre descriptivo.
 *   3. Sumalo al objeto bajo la variante correspondiente.
 *
 * Variantes previstas (agregar a medida que lleguen los assets de diseño):
 *   - empty:   { cloud: ... }   // ej: completeEmptyCloud.webp
 *   - info:    { cloud: ... }
 */
export const MASCOT_MAP = {
  error: {
    cloud: completeSadCloud,
  },
  success: {
    cloud: completeFriendlyCloud,
  },
  hello: {
    cloud: completeHelloCloud,
  },
  warning: {
    cloud: completedAlertCloud,
  },
} as const;

export type MascotVariant = keyof typeof MASCOT_MAP;
export type MascotName = "cloud";
